import { render, staticRenderFns } from "./DetalhePenalidade.vue?vue&type=template&id=87a8aa64&scoped=true"
import script from "./DetalhePenalidade.vue?vue&type=script&lang=js"
export * from "./DetalhePenalidade.vue?vue&type=script&lang=js"
import style0 from "./DetalhePenalidade.vue?vue&type=style&index=0&id=87a8aa64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a8aa64",
  null
  
)

export default component.exports